import React, { Children, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { range } from 'lodash';

import { Label } from 'components/core/Label';
import StarButton from './StarButton';

import './StarInput.scss';


export function StarInput({
	classsName, halfStep, totalStars = 5, label, size, input
}) {
	const stars = useMemo(() => {
		const numElements = halfStep ? totalStars * 2 : totalStars;
		return range(1, numElements + 1).map((index) => (halfStep ? index / 2 : index));
	}, [halfStep, totalStars]);

	const onSelect = useCallback((value) => input.onChange(`${value}`), [input]);

	const [activeRating, setActiveRating] = useState(() => parseFloat(input.value));

	const onMouseEnter = useCallback((value) => setActiveRating(value), []);
	const onMouseLeave = useCallback(() => setActiveRating(parseFloat(input.value)), [input]);

	return (
		<Label
			text={label}
			htmlFor={input.id || input.name}
			className={classnames('star-input', size, classsName)}
			textAfterChildren={false}
		>
			<div className="input-container">
				{Children.toArray(stars.map((value) => (
					<StarButton
						className={
							classnames(
								size,
								{
									half: halfStep,
									active: activeRating >= value
								}
							)
						}
						onMouseEnter={onMouseEnter}
						onMouseLeave={onMouseLeave}
						onClick={onSelect}
						value={value}
					/>
				)))}
			</div>
		</Label>
	);
}

StarInput.propTypes = {
	classsName: PropTypes.string,
	halfStep: PropTypes.bool,
	totalStars: PropTypes.number,
	label: PropTypes.string,
	size: PropTypes.string,
	input: PropTypes.object
};

export default StarInput;
